import React, { Fragment } from 'react';

import { useUser } from 'hooks';
import { User } from 'types';
import { formatUtils } from 'utils';

type Props = {
  processor?: Partial<User>;
  processedAt?: string;
};

export const ProcessedByInfo: React.FC<Props> = ({
  processor,
  processedAt,
}) => {
  const { isAdminOrTechOperator } = useUser();

  return (
    <Fragment>
      {isAdminOrTechOperator && processor?.name && <div>{processor.name}</div>}
      {processedAt && <div>{formatUtils.formatDate(processedAt)}</div>}
    </Fragment>
  );
};
